import React, { useState } from 'react' 
import { toast } from 'react-toastify'
import { 
  Button, 
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, 
  TextField
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import EsimAPI from 'api/faber/EsimAPI'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

import { TransformedFaberAndGlobalUsersType } from '../../OTPacks/Global/components/UserProfileV3'

function EsimAllocateByWhitelistIDDialog({
  isEsimAllocateByWhitelistIDDialogOpen,
  handleCancelEsimAllocateByWhitelistIDDialog,
  faberToken,
  customerRow
}: RequestDialogProps) {
  const [whitelistId, setWhitelistId] = useState('')

  const {
    mutate: esimAllocateByWhitelistIDMutate,
    isLoading: esimAllocateByWhitelistIDMutateLoading
  } = useMutation(EsimAPI.esimAllocateByWhitelistID, {
    onSuccess: () => {
      setWhitelistId("")
      handleCancelEsimAllocateByWhitelistIDDialog()
      toast.success(
        'eSIM allocated successfully. Please refresh page to see updated status'
      )
    },
    onError: () => {
      setWhitelistId('')
      toast.error('Failed to allocate eSIM. Please escalate to the devs')
    },
    onSettled: () => {
      setWhitelistId('')
      handleCancelEsimAllocateByWhitelistIDDialog()
    }
  })

  const handleReprovisionEsim = () => {

    const data = {
      user_id: customerRow?.userID,
      user_email: customerRow?.userEmail ?? '',
      user_name: `${customerRow?.firstName} ${customerRow?.lastName}`,
      Whitelist_id: whitelistId,
      faberToken: faberToken
    }
    esimAllocateByWhitelistIDMutate({
      ...data
    })
  }

  return (
    <Dialog
      open={isEsimAllocateByWhitelistIDDialogOpen}
      onClose={handleCancelEsimAllocateByWhitelistIDDialog}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>Confirm eSIM Allocate by Whitelist ID</DialogTitle>
      <DialogContent>
        <DialogContentText>
         Enter Whitelist ID to allocate eSim
        </DialogContentText>

        {/* ✅ Added input for Whitelist ID */}
        <TextField
          fullWidth
          label='Whitelist ID'
          variant='outlined'
          value={whitelistId}
          onChange={(e) => setWhitelistId(e.target.value)}
          sx={{ mt: 3 }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          disabled={esimAllocateByWhitelistIDMutateLoading}
          onClick={handleCancelEsimAllocateByWhitelistIDDialog}
          color='inherit'
        >
          Cancel
        </Button>
        <Button
          disabled={
            esimAllocateByWhitelistIDMutateLoading || whitelistId?.length === 0
          }
          onClick={handleReprovisionEsim}
          variant='contained'
          autoFocus
        >
          Allocate eSIM
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EsimAllocateByWhitelistIDDialog

interface RequestDialogProps {
  handleCancelEsimAllocateByWhitelistIDDialog: () => void
  isEsimAllocateByWhitelistIDDialogOpen: boolean
  customerRow: SubscriptionsTableRows | TransformedFaberAndGlobalUsersType
  faberToken: string
}
